"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const clsx_1 = __importDefault(require("clsx"));
const CheckBox = ({ label, name, checked, defaultChecked, onChange, isInline, isDisabled, isRequired, className, }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: isInline, className: "pl-0 flex items-center" },
        react_1.default.createElement(react_bootstrap_1.FormCheck.Input, { type: "checkbox", name: name, id: name, "aria-label": label, bsPrefix: (0, clsx_1.default)('custom-checkbox-input', className), checked: checked, defaultChecked: defaultChecked, onChange: onChange, disabled: isDisabled }),
        react_1.default.createElement(react_bootstrap_1.FormCheck.Label, { htmlFor: name },
            label,
            isRequired && react_1.default.createElement("span", { "aria-label": "required field" }, "*")))));
exports.default = CheckBox;
